import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import AddIcon from '@mui/icons-material/Add';
import { Box, Divider, Typography } from '@mui/material';
import React from 'react';

interface AddFoodNoteButtonProps {
    restaurantOfferStore: RestaurantOfferStore
}

const AddFoodNoteButton: React.FC<AddFoodNoteButtonProps> = ({ restaurantOfferStore }) => {
    const { setIsFoodNoteDialogOpen } = restaurantOfferStore;
    return (
        <Box mt={2}>
            <Divider />
            <Typography
                onClick={() => setIsFoodNoteDialogOpen(true)}
                mt={1}
                color="secondary"
                variant='subtitle2'
                fontWeight={600}
                sx={{
                    ":hover": {
                        textDecoration: "underline",
                        cursor: "pointer"
                    }
                }}>
                <Box display={"flex"} gap={0.5} alignItems={"center"}>
                    <AddIcon />
                    Dodaj napomenu
                </Box>
            </Typography>
        </Box>
    )
}

export default AddFoodNoteButton;